import type { AppConfig } from '../config/types';
import { setAppConfig } from '../config/appConfigRef';
import { createApiInstances } from './clients';
import { wireSessionToApi } from '../auth/wireSessionToApi';

export function initPlatformApi(config: AppConfig): void {
  setAppConfig(config);
  createApiInstances(config.accountApiUrl, config.mainApiUrl, config.apiTimeout);
  wireSessionToApi();
}
